'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_Image(id_$_lo, id_$_hi, accountId_$_lo, accountId_$_hi, extension, originalUrl, caption) {
  this.xt = 0;
  this.xu = 0;
  this.Vt = 0;
  this.Vu = 0;
  this.Ls = null;
  this.Lt = null;
  this.Sl = null;
  this.xt = id_$_lo;
  this.xu = id_$_hi;
  this.Vt = accountId_$_lo;
  this.Vu = accountId_$_hi;
  this.Ls = extension;
  this.Lt = originalUrl;
  this.Sl = caption;
}
export { $c_Lmealorama_Image as $c_Lmealorama_Image };
$p = $c_Lmealorama_Image.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_Image;
/** @constructor */
function $h_Lmealorama_Image() {
}
export { $h_Lmealorama_Image as $h_Lmealorama_Image };
$h_Lmealorama_Image.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, 612005409, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_Image)) {
    var x_$_lo = this.xt;
    var x_$_hi = this.xu;
    var $x_3 = x$0;
    var x$1_$_lo = $x_3.xt;
    var x$1_$_hi = $x_3.xu;
    if ((((x_$_lo ^ x$1_$_lo) | (x_$_hi ^ x$1_$_hi)) === 0)) {
      var x$2_$_lo = this.Vt;
      var x$2_$_hi = this.Vu;
      var $x_4 = x$0;
      var x$3_$_lo = $x_4.Vt;
      var x$3_$_hi = $x_4.Vu;
      var $x_2 = (((x$2_$_lo ^ x$3_$_lo) | (x$2_$_hi ^ x$3_$_hi)) === 0);
    } else {
      var $x_2 = false;
    }
    if (($x_2 && (this.Ls === x$0.Ls))) {
      var x$4 = this.Lt;
      var x$2$1 = x$0.Lt;
      var $x_1 = ((x$4 === null) ? (x$2$1 === null) : x$4.f(x$2$1));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$3$1 = this.Sl;
      var x$4$1 = x$0.Sl;
      return ((x$3$1 === null) ? (x$4$1 === null) : x$3$1.f(x$4$1));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 5;
});
$p.r = (function() {
  return "Image";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.xt, this.xu);
      break;
    }
    case 1: {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$bL(this.Vt, this.Vu);
      break;
    }
    case 2: {
      return this.Ls;
      break;
    }
    case 3: {
      return this.Lt;
      break;
    }
    case 4: {
      return this.Sl;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_Image(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jA)));
}
export { $isArrayOf_Lmealorama_Image as $isArrayOf_Lmealorama_Image };
var $d_Lmealorama_Image = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_Image, "mealorama.Image", ({
  jA: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_Image as $d_Lmealorama_Image };
//# sourceMappingURL=mealorama.-Image.js.map
